import { wrapCreateBrowserRouterV7 } from '@sentry/react';
import type { FunctionComponent } from 'react';

import { RouterProvider } from 'react-router';
import { createBrowserRouter } from 'react-router-dom';
import { routes } from './routes/Routes.tsx';
import { useAuth } from './components/management/NewAuthProvider';
import { Box } from '@mui/joy';

const sentryCreateBrowserRouter = wrapCreateBrowserRouterV7(createBrowserRouter);
const router = sentryCreateBrowserRouter(routes, {
  future: {
    v7_relativeSplatPath: true,
  },
});

const RootOutlet: FunctionComponent = () => {
  const { initialized } = useAuth();
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'stretch',
      }}
    >
      {initialized && <RouterProvider router={router} future={{ v7_startTransition: true }} />}
    </Box>
  );
};

export default RootOutlet;
